import React from 'react';
import Button from '@aurora/shared-client/components/common/Button/Button';
import { ButtonVariant } from '@aurora/shared-client/components/common/Button/enums';
import useTranslation from '../../useTranslation';
import { EndUserComponent } from '@aurora/shared-types/pages/enums';
import localStyles from './SurveyPromptFloatingBox.module.pcss';
import { useClassNameMapper } from 'react-bootstrap';

interface Props {
  /**
   * Callback to be used when the survey prompt is accepted
   */
  onAccept: () => void;

  /**
   * Callback to be used when the survey prompt is rejected
   */
  onReject: () => void;
}

export const SURVEY_PROMPT_FLOATING_BOX = 'surveyPromptFloatingBox';

/**
 * Survey Prompt Floating Box, prompts the user to take a survey
 *
 * @author Adam Ayres
 */
const SurveyPromptFloatingBox: React.FC<Props> = ({ onAccept, onReject }) => {
  const cx = useClassNameMapper(localStyles);
  const { loading, formatMessage } = useTranslation(EndUserComponent.SURVEY_PROMPT_FLOATING_BOX);

  if (loading) {
    return null;
  }

  return (
    <div className={cx('lia-box')}>
      <h3 className={cx('lia-g-mb-5')}>{formatMessage('title')}</h3>
      <small className={cx('lia-g-mb-15 d-block')}>{formatMessage('description')}</small>
      <section className={cx('d-flex flex-column lia-g-column-gap-10')}>
        <Button variant={ButtonVariant.PRIMARY} onClick={onAccept} block>
          {formatMessage('yes')}
        </Button>
        <Button variant={ButtonVariant.LIGHT} onClick={onReject} block>
          {formatMessage('no')}
        </Button>
      </section>
    </div>
  );
};

export default SurveyPromptFloatingBox;
